<template>
  <div>
    {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute"
           width="100%">
      <!-- ContenidoBase-Notas de Debito -->
      <tr height="48px" max-height="48px">
        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'aqui se registran los vendedores de la empresa'"
                       :titulo="'Notas de Débito'" @MethodAnular="anular" @MethodEliminar="remove"
                       @MethodGuardar="presave"
                       @MethodImprimir="imprimirList" @MethodNuevo="newwnuevo" @MethodVeercuenta="vercuenta"
                       @abrirBarraTablaDinamica="abrirTabla"/>
      </tr>
      <!-- fn ContenidoBase-Notas de Debito -->
      <tr>
        <!-- BarraPrimaria-Notas de Debito --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->
                <!-- <v-navigation-drawer >  -->
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"> </i>
                      ver
                    </v-btn>

                    <v-btn color="teal darken-2" dark small text @click.prevent="
                      (dialogFiltros = true),
                      (ObjTemTbDinam = JSON.parse(
                        JSON.stringify(Modallfiltro)
                      ))
                    ">
                      <i class="fa fa-search" style="font-size: 25px"> </i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </center>

                <BarraDinamicaLimitePlus :ContListSlot="[
  {
    Text: 'Código',
    NomValue: 'notadebitoclientesPK',
    Nv2: 'secuencia',
    Ctsl: 2,
    Type: 0,
    State: true,
  },
  {
    Text: 'Nombre',
    NomValue: 'cliente',
    Nv2: 'nombre',
    Ctsl: 2,
    Type: 0,
    State: true,
  },
  {
    Text: 'Valor $',
    NomValue: 'valor',
    Ctsl: 1,
    Type: 2,
    State: true,
  },
  {
    Text: 'referencia',
    NomValue: 'referencia',
    Ctsl: 1,
    Type: 0,
    State: true,
  },
  {
    Text: 'concepto',
    NomValue: 'concepto',
    Ctsl: 1,
    Type: 0,
    State: true,
  },
  {
    Text: 'ncf',
    NomValue: 'ncf',
    Ctsl: 1,
    Type: 0,
    State: true,
  },
  {
    Text: 'Estado',
    NomValue: 'activada',
    Ctsl: 1,
    Type: 0.1,
    State: true,
  },
]" :PropsList="ListItems"
                                         :PropsNombre="'Notas de Débito'" :PropsSeachNombre="'Búsqueda por código'"
                                         :TbPaginator="TbPaginator"
                                         :TbTotalItem="TbTotalItem" :headers="[
                    { text: 'Código', value: 'notadebitoclientesPK.secuencia' },
                    { text: 'cliente', value: 'cliente.nombre' },
                    { text: 'valor', value: 'valor' },
                    { text: 'concepto', value: 'concepto' },
                    { text: 'referencia', value: 'referencia' },
                    { text: 'ncf', value: 'ncf' },
                    { Text: 'Estado', NomValue: 'activada', Ctsl: 1, Type: 0.1, State: true }
                    /* { text: 'Nombre', value: 'nombre' },
                  { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]"
                                         PropsSearchNumber @CargarPaginacion="CargarPaginacion"
                                         @EmitDAta="datostabla"/>
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- BarraPrimaria-Notas de Debito --------------------------------------------------------------------------------->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto"
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <!-- Formulario-Notas de Debito   -->
            <div class="px-2">
              <v-card color="grey lighten-3">
                <div class="px-2">
                  <v-form ref="form" v-model="valid" lazy-validation translate="no" class="notranslate">
                    <v-row dense>
                      <input v-model="NotaDebito.notadebitoclientesPK.secuencia" style="display: none" type="number"/>
                  <!--  -->
                      <v-col cols="12" md="3">
                        <v-combobox id="formdisabledInput" v-model="NotaDebito.documentocxc"
                                    :disabled="disabledDocumento" :items="RDocumento" :rules="[$rules.required]"
                                    autocomplete="off" dense item-text="descripcion"
                                    label="Documentos:" outlined @blur="SelctCbDocumento"
                                    @change="getCrear" @focus="cargarDocumento"
                                    style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-book" style="font-size: 18px"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" sm="2">
                      <v-text-field id="formdisabledInput" v-model="NotaDebito.fecha" :disabled="disableAll"
                                                            :rules="[$rules.required]" dense
                                                            label="Fecha"
                                                            outlined type="date" @blur="buscarPeriodo"
                                                            style="font-size: 12px;" >
                                                <template v-slot:prepend>
                                                  <i class="fa fa-calendar" style="font-size: 18px"></i>
                                                </template>
                      </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                      <v-combobox id="formdisabledInput" v-model="NotaDebito.cliente" :disabled="disabledDocumento"
                                    :items="RCliente" :rules="[$rules.required]"
                                    :suffix="clientTel" autocomplete="off" dense item-text="codnom"
                                    label="cliente:" no-filter
                                    outlined
                                    style="font-size: 13px" @blur="SelctCbCliente" @change="ClienteSelect"
                                    @focus="cargarCliente"
                                    @keyup="CbFilcliente" v-on:change="getCrear(),FactPendientes()">
                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                              }}</span>
                            <span
                                class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                          </template>
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 18px"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" sm="3">
                          <!--- Vendedor --->
                        <v-autocomplete
                            v-model="NotaDebito.vendedor"
                            :items="vendedoresList"
                            :search-input.sync="searchVendedor"
                            clearable
                            dense
                            item-text="nombre"
                            label="Vendedor:"
                            no-filter
                            outlined
                            return-object
                            style="font-size: 12px;"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user" style="font-size: 18px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                 <!--  -->
                  <!--  -->
                    <v-col cols="12" md="3">
                    <VueAutonumeric id="formdisabledInput" v-model.number="NotaDebito.valor" :disabled="disableAll"
                                                            :rules="[$rules.required]" autocomplete="off"
                                                            dense label="Valor:" outlined
                                                            @blur="getCrear"
                                                            @input="getValorNBD(NotaDebito.valor)"
                                                            
                                                            >
                                              <template v-slot:prepend>
                                                <i class="fa fa-dollar" style="font-size: 20px"></i>
                                              </template>
                                            </VueAutonumeric>

                                            <v-text-field id="formdisabledInput" v-model="NotaDebito.diasCredito" :disabled="disableAll"
                                                            dense
                                                            label="Días de Crédito"
                                                            outlined @keyup="DiaCre">
                                                <template v-slot:prepend>
                                                  <i class="fa fa-credit-card" style="font-size: 20px"></i>
                                                </template>
                       </v-text-field>
                                            
                    </v-col>
                    <v-col cols="12" md="3">
                     <VueAutonumeric id="formdisabledInput" v-model.number="NotaDebito.itbis" :disabled="disableAll"
                                                            autocomplete="off" dense
                                                            label="ITBIS:" outlined @blur="getCrear">
                                              <template v-slot:prepend>
                                                <i class="fa fa-usd" style="font-size: 20px"></i>
                                              </template>
                    </VueAutonumeric>
                      <div v-if="this.$store.getters.GetConfiguracionGeneral.config.multimoneda==true">
                      <v-combobox id="formdisabledInput" v-model="NotaDebito.moneda" :items="Rmoneda"
                                      :rules="[$rules.required]" autocomplete="off"
                                      dense item-text="descripcion"
                                      label="Monedas" outlined style="font-size:13px;"
                                      @blur="SelctCbMoneda"
                                      @change="ChangeMonedaTasa" @focus="cargarMoneda">

                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px;"></i>
                            </template>

                            <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span id="ImputColorDisable">
                      {{ item.descripcion }} ({{ item.nombrecorto }})
                    </span>

                            </template>


                            <template slot="item" slot-scope="item">
                              <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="font-size: 13px;">
                                <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{
                                    item.item.nombrecorto
                                  }})</b>
                                </p>
                              </v-col>
                            </template>
                          </v-combobox>
                      </div>

                    </v-col>
                    <v-col cols="12" md="3">
                  <v-text-field id="formdisabledInput" v-model="NotaDebito.referencia" :disabled="disableAll"
                                                      dense
                                                      label="Referencia"
                                                      maxlength="30"
                                                      outlined>
                                          <template v-slot:prepend>
                                            <i class="fa fa-map-signs" style="font-size: 20px"></i>
                                          </template>
                                        </v-text-field>

                               
                        <div  v-if="this.$store.getters.GetConfiguracionGeneral.config.multimoneda==true">
                          <VueAutonumeric v-if="NotaDebito.moneda != null" id="formdisabledInput"
                                          v-model.number="NotaDebito.moneda.tasa"
                                          dense label="Tasa Compra:"
                                          outlined
                                          @input="NotaDebito.tasa=NotaDebito.moneda.tasa">
                            <template v-slot:prepend>
                              <i class="fa fa-usd" style="font-size: 20px;"></i>
                            </template>
                          </VueAutonumeric>
                        </div>

                    </v-col>
                    <v-col cols="12" md="3">
                        <v-textarea id="formdisabledInput" v-model="NotaDebito.concepto" :disabled="disableAll"
                                    autocomplete="off" dense
                                    label="Concepto"
                                    outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-commenting" style="font-size: 20px"></i>
                          </template>
                        </v-textarea>
                    </v-col>
                  <!--  -->
                    <v-col cols="12" md="3">
                      
                    </v-col>
                
                    <v-col cols="12" md="3">
                      
                    </v-col>
                  <!--  -->
                    </v-row>
                  </v-form>
                  <!--------------------------------------------------- Factura Electronica -->

                <v-col v-if="NotaDebito.hasOwnProperty('trackId') &&  NotaDebito.trackId!=null" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
                  <v-card>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                      <span><b>Facturación Electrónica</b></span>
                    </v-col>

                    <!-- cuerpo FACTURACION ELETRONICA -->
                    <v-col cols="12" md="12" sm="12">
                      <v-row>
                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">

                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                          <v-text-field id="formdisabledInput" :value="NotaDebito.signatureValue"
                                        autocomplete="off" dense
                                        disabled
                                        hide-details label=" signatureValue:" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-shield" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                          <v-text-field id="formdisabledInput" :value="NotaDebito.fechafirmadgii"
                                        autocomplete="off"
                                        dense disabled
                                        hide-details label="fechafirmadgii" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="NotaDebito.qrdgii" auto-grow
                                      autocomplete="off" dense
                                      disabled hide-details label="QR:" outlined
                                      rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="NotaDebito.trackId" auto-grow
                                      autocomplete="off" dense
                                      hide-details label="trackId:" outlined rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
<pre style="font-size: 10px;">
  AMBIENTE:(testecf/certecf/ecf)
  CONSULTA:
  1- https://ecf.dgii.gov.do/{AMBIENTE}/consultaresultado/help/index.html
  2- https://ecf.dgii.gov.do/{AMBIENTE}/consultaestado/help/index.html
</pre>


                        </v-col>


                      </v-row>
                    </v-col>
                    <!-- FINcuerpo FACTURACION ELETRONICA -->

                  </v-card>

                </v-col>

                  <!--------------------------------------------------- FN Factura Electronica -->
                  
                  <v-col  class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                   <!--------------------------------------------------- tb-Factura Pendiente -->
                  <v-card>

                    <v-toolbar color="#BDBDBD" dense flat>
                      <v-toolbar-title class="font-weight-light">
                        <v-card-title>FACTURAS PENDIENTE </v-card-title>
                      </v-toolbar-title>

                    </v-toolbar>
                    <v-data-table
                    @current-items="calcularTotalFooter()"
                     id="TbBord" v-model="facSelected" :loading="loaderTabla"
                    :headers="[{ text: 'FECHA', value: 'fecha',sortable: false, width: 90, class: ['no-gutters black--text'] }, 
                    { text: 'FACTURA', value: 'factura', width: 150, class: ['no-gutters black--text'] }, 
                    { text: 'NCF', value: 'ncf', width: 100, sortable: false, class: ['no-gutters black--text'] },
                      { text: 'ITBIS', value: 'itbis',sortable: false, width: 'auto',  align: 'center', class: ['no-gutters black--text'] },
                      { text: 'TASA', value: 'tasa',sortable: false, width: 100, class: ['no-gutters black--text'] },
                      { text: 'VALOR', value: 'valor',sortable: false,align: 'center', class: ['no-gutters black--text'] },
                      { text: 'VALOR NDB', value: 'valorNdb', width: 'auto', sortable: false,align: 'center', class: ['no-gutters black--text'] }, 
                      { text: 'BALANCE', value: 'balanceTotal', width: 100,sortable: false, align: 'end', class: ['no-gutters black--text'] }]"
                                  :items="listaFactura" :items-per-page="10"
                                  :show-select="ShowSelet"
                                  :single-select="true" class="elevation-1 RowSelectColor"
                                  dense
                                  item-key="indx" @item-selected="obtenerDatoDetFact" @click:row="datosRowSelect">

                      <template v-slot:no-data>
                        <v-card-title>FACTURAS PENDIENTE </v-card-title>

                        <v-sheet v-if="tbFacCargar" :color="`grey ${theme.isDark ? 'darken-2' : 'red darken-1'}`"
                                 class="px-3 pt-3 pb-3">
                          <v-skeleton-loader class="mx-auto" max-width="auto" type="card"></v-skeleton-loader>
                        </v-sheet>
                      </template>


                      <template v-slot:item.fecha="props">
                        <span style="display:none;">{{ props.item.indx = listaFactura.indexOf(props.item) }}</span>
                        <p style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}</p>

                      </template>

                      <template v-slot:item.factura="props">

                        <p style="font-size:13px;">
                          {{ props.item.documentoFactura.nombrecorto}}-{{ props.item.facturasventaPK.secuencia }}
                        </p>

                      </template>

                      <template v-slot:item.ncf="props">
                        <p style="font-size:13px;">{{ props.item.ncf }}</p>
                      </template>

                      <template v-slot:item.tasa="props">
                        <p style="font-size:13px;">{{ currencyFormatter(props.item.tasa) }}  </p>
                      </template>


                      <!--aquii -->

                      <!--------------------------------------------------  valor -->

                      <template v-slot:item.valor="props">
                        <p style="font-size:13px;">
                          <!-- ${{ currencyFormatter(props.item.facturasventa.valor) }} -->
                          ${{
                            currencyFormatter2MonedaConv(props.item.valor, NotaDebito.tasa)
                          }}</p>
                      </template>

                      <!--------------------------------------------------  pendiente -->
                      <template v-slot:item.pendiente="props">
                        <p style="font-size:13px;">
                          <!-- ${{ currencyFormatter(props.item.pendiete) }} -->
                          ${{ currencyFormatter2MonedaConv(props.item.pendiete, NotaDebito.tasa) }}
                        </p>
                      </template>
                      <!--------------------------------------------------  valornc -->

                      <template v-slot:item.valorNdb="props">
                        <p style="font-size:13px;">
                          <!-- ${{ currencyFormatter(props.item.valorNCR) }} -->
                          ${{ currencyFormatter2MonedaConv(props.item.valorNdb, NotaDebito.tasa) }}
                        </p>
                      </template>
                      <!--------------------------------------------------  itbis -->
                      <template v-slot:item.itbis="props">
                        <p style="font-size:13px;">
                          <!-- $ {{ currencyFormatter(props.item.facturasventa.itbis) }}  -->
                          ${{
                            currencyFormatter2MonedaConv(props.item.itbis, NotaDebito.tasa)
                          }}</p>

                   
                      </template>
                      <!--------------------------------------------------  valor -->


                      <template v-slot:item.balanceTotal="props">
                        <p v-if="props.item.balanceTotal >= 0" style="font-size:13px;">
                          <!-- {{ currencyFormatter(props.item.balanceTotal) }} -->
                          ${{ currencyFormatter2MonedaConv(props.item.balanceTotal, NotaDebito.tasa) }}
                        </p>
                        <p v-if="props.item.balanceTotal < 0" style="font-size:13px;">
                          <!-- (${{ currencyFormatter(props.item.balanceTotal) }} ) -->
                          (${{ currencyFormatter2MonedaConv(props.item.balanceTotal, NotaDebito.tasa) }})
                        </p>
                      </template>

                      <!-- currencyFormatter -->
                      <template v-if="windowSize.width > 600" v-slot:body.append>
                        <tr>
                          <td v-if="ShowSelet == true" class="border-top-bottom"><strong></strong></td>
                          <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-top-bottom"><strong class="d-flex justify-end" style="font-size:13px;">Totales:</strong>
                          </td>
                          <!-- <td class="border-top-bottom"  ><strong></strong></td> -->

                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            <!-- {{ currencyFormatter(form.Total.itbis) }}  -->
                            {{ currencyFormatter2MonedaConv(totalGeneral.itbis, NotaDebito.tasa) }}
                          </strong></td>
                          <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            <!-- {{ currencyFormatter(totalGeneral.valor) }}  -->
                            {{ currencyFormatter2MonedaConv(totalGeneral.valor, NotaDebito.tasa) }}
                          </strong></td>
                         
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            <!-- {{ currencyFormatter(totalGeneral.ncr) }} -->
                            {{ currencyFormatter2MonedaConv(totalGeneral.valorNdb, NotaDebito.tasa) }}
                          </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            <!-- {{ currencyFormatter(totalGeneral.balanceTotal) }}  -->
                            {{ currencyFormatter2MonedaConv(totalGeneral.balanceTotal, NotaDebito.tasa) }}
                          </strong></td>
                        </tr>
                      </template>

                      <template v-if="windowSize.width <= 600" v-slot:footer>
                        <v-list-item class="white--text" style="font-size: 70%;">
                          <v-list-item-content>
      <span> ITBIS:<!--{{currencyFormatter(form.Total.itbis)}}-->{{
          currencyFormatter2MonedaConv(totalGeneral.itbis, NotaDebito.tasa) }}
      </span>
      <span> VALOR:<!-- {{ currencyFormatter(form.Total.valor) }} -->{{
              currencyFormatter2MonedaConv(totalGeneral.valor, NotaDebito.tasa)}}
      </span>
      <span> NDB:<!-- {{ currencyFormatter(form.Total.ncr) }} -->{{
             currencyFormatter2MonedaConv(totalGeneral.valorNdb, NotaDebito.tasa) }}
      </span>
       <span>BALANCE-TOTAL:<!-- {{ currencyFormatter(form.Total.balanceTotal) }}  -->{{
              currencyFormatter2MonedaConv(totalGeneral.balanceTotal, NotaDebito.tasa) }}
      </span>

                          </v-list-item-content>
                        </v-list-item>

                      </template>


                    </v-data-table>
                  </v-card>
                  <!--------------------------------------------------- fn tb Factura inicial -->
                  </v-col>
                </div>
              </v-card>
            </div>
            <!-- fn Formulario-Notas de Debito   -->
          </v-app>
        </td>
        <td v-if="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-btn id="boton-mini" color="red darken-3" dark small text width="100%" @click.prevent="abrirTabla2">Cerrar

              <i class="fa fa-close" style="font-size: 25px"> </i>
            </v-btn>

            <ClienteInformacion :Obje="ObjCliente"/>
          </div>
        </td>
      </tr>
    </table>
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog v-model="acti_tb_data" fullscreen hide-overlay label="myAlert" persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="deep-purple accent-2" dark small v-on="on" @click.prevent="dialogimprimirListFilt = true">
                <i class="fa fa-print" style="font-size: 25px"> </i>
                Listado
              </v-btn>
            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>
          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="Modallfiltro.factura" hide-details label="Buscar" single-line
                            @keyup.enter="CargarListTb">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="[
              {
                text: 'Nombre',
                value: 'cliente.nombre',
                width: 300,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Cedula/Rnc:',
                value: 'cliente.cedrnc',
                width: 150,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Balance:',
                value: 'cliente.balancecliente.balance',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Email:',
                value: 'cliente.email',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Dirección',
                value: 'cliente.direccion',
                width: 250,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Documento:',
                value: 'documentocxc.descripcion',
                width: 220,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Referencia',
                value: 'referencia',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Valor',
                value: 'valor',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'ITBIS',
                value: 'itbis',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Días de Crédito',
                value: 'diasCredito',
                width: 120,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Concepto',
                value: 'concepto',
                width: 200,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Fecha',
                value: 'fecha',
                width: 200,
                class: ['no-gutters black--text'],
                sortable: false,
              },
              {
                text: 'Estado',
                value: 'activada',
                width: 200,
                class: ['no-gutters black--text'],
                sortable: false,
              },
            ]" :items="ListItems" :items-per-page="TbPaginator.itemsPerPage" :page="TbPaginator.page"
                          :pageCount="TbPaginator.pageCount"
                          :search="Modallfiltro.factura" :server-items-length="TbTotalItem" class="TbSize13"
                          dense @pagination="cargarPaginacionAll" @click:row="datostabla">
              <template v-slot:item.fecha="props">
                <span>{{ fecFormatter(props.item.fecha) }}</span>
              </template>

              <template v-slot:item.cliente.balancecliente.balance="props">
                <span>{{
                    currencyFormatter(props.item.cliente.balancecliente.balance)
                  }}</span>
              </template>

              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>

              <template v-slot:item.itbis="props">
                <span>{{ currencyFormatter(props.item.itbis) }}</span>
              </template>

              <template v-slot:item.diasCredito="props">
                <span>{{ currencyFormatter(props.item.diasCredito) }}</span>
              </template>

              <template v-slot:item.cliente.direccion="props">
                <span>{{ props.item.cliente.ciudad }},
                  {{ props.item.cliente.direccion }}</span>
              </template>

              <template v-slot:item.activada="props">
                <span v-if="props.item.activada == false">Anulada</span>
                <span v-if="props.item.activada == true">Activa</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ tb-data todo general -->

    <!-- ------------------------------------------------------ Modal-agregar cuenta -->

    <v-dialog v-model="acti_Modal_cuenta" label="Modal agregar cuenta" max-height="80%" max-width="90%"
              persistent transition="fab-transition">
      <CuentasContables ref="RefCuentasContables" :RLisCuenta="RLisCuenta" :Total="TotalCuenta"
                        :objeTem="objeTem"
                        @CuentasContables="CCuentasContables"/>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-agregar cuenta-->

    <!-- ------------------------------------------------------ Modal- nueva cuenta-->
    <v-dialog v-model="acti_Nueva_cuenta" label="Modal agregar cuenta" max-height="50%" max-width="60%"
              persistent transition="fab-transition">
      <v-card>
        <v-toolbar color="indigo" flat>
          <i class="" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            Crear Cuenta Nueva
          </v-toolbar-title>
          <i class="" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_Nueva_cuenta = !acti_Nueva_cuenta">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br/>

          <NuevaCuenta @NuevaCuenta="NnuevaCuenta"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal nueva cuenta-->

    <!-- ------------------------------------------------------ Modal-notificacion general -->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr/>

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr/>
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          ">
            <i class="fa fa-check" style="font-size: 20px"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Modal-notificacion general -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true" style="margin-top: 20%"
                top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!-- ------------------------------------------------------ Modal-Filtro tb-datos -->
    <v-dialog v-model="dialogFiltros" label="Modal agregar factura" max-height="80%" max-width="90%"
              persistent transition="fab-transition">
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            <b>FILTROS</b>
          </v-toolbar-title>
          <i class="" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="
            (dialogFiltros = false),
            (Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam)))
          ">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br/>

          <v-row>
            <v-col cols="12" md="12">
              <!-------------------------------------------------- Nombre  -->

              <v-combobox v-model="Modallfiltro.cliente" :items="RCliente" :rules="[$rules.required]" autocomplete="off"
                          dense item-text="codnom"
                          label="Nombre:" no-filter outlined
                          @blur="SelctCbClienteFiltro" @focus="cargarCliente" @keyup="CbFilcliente">
                <template slot="item" slot-scope="item">
                  <span style="display:none;">{{
                      item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                    }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                </template>

                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <span class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                </template>
                <template v-slot:prepend>
                  <i class="fa fa-user-circle" style="font-size: 20px"></i>
                </template>
              </v-combobox>

              <!---------------------------------------------- documento -->
              <v-combobox v-model="Modallfiltro.documento" :items="RDocumento" :rules="[$rules.required]"
                          autocomplete="off" dense
                          item-text="descripcion" label="Documentos:" outlined
                          @blur="SelctCbDocumentoFiltro" @focus="cargarDocumento">
                <template v-slot:prepend>
                  <i class="fa fa-book" style="font-size: 20px"></i>
                </template>
              </v-combobox>
            </v-col>

            <!-- -----------------------------  columna-1 -->
            <v-col cols="6" md="6">
              <!----------------------------------------------  Desde -->
              <v-text-field v-model="Modallfiltro.Desde" dense label="Desde*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-1 -->

            <!-- -----------------------------  columna-2 -->
            <v-col cols="6" md="6">
              <!-------------------------------------------------- Hasta -->
              <v-text-field v-model="Modallfiltro.Hasta" dense label="Hasta*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-2 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle class="" dense rounded>
            <v-btn color="#90A4AE" @click.prevent="Limpiarfiltro">
              <i class="fa fa-file-o" style="font-size: 28px"> </i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" @click.prevent="BuscarFiltros">
              <i class="fa fa-search" style="font-size: 28px"> </i>
              Buscar
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal-Filtro tb-datos -->

    <!-- ------------------------------------------------------ Modal- Reportes-->
    <v-dialog v-model="dialogimprimirListFilt" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">
        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
          <v-avatar size="45" tile>
            <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png"/>
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px">
            <b>REPORTE LISTADO DE NOTA DE DEBITO </b>
          </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <hr/>

        <v-container style="border: 1px solid #000000">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" md="6" sm="6">
                <v-text-field v-model="datosImprecionAll.fecini" :rules="[$rules.required]" dense label="Desde*"
                              outlined
                              type="date">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>

                <!---------------------------------------------- documento -->
                <v-combobox v-model="datosImprecionAll.documentos" :items="RDocumento" :rules="[$rules.required]"
                            autocomplete="off" dense
                            item-text="descripcion" label="Documentos:" outlined
                            @blur="SelctCbReportDocumento" @focus="cargarDocumento">
                  <template v-slot:prepend>
                    <i class="fa fa-book" style="font-size: 20px"></i>
                  </template>
                </v-combobox>

              </v-col>

              <v-col cols="12" md="6" sm="6">
                <!-------------------------------------------------- Hasta -->
                <v-text-field v-model="datosImprecionAll.fecfin" :rules="[$rules.required]" dense label="Hasta*"
                              outlined
                              type="date">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>

                <!--- Vendedor filtro reporte --->
                <v-autocomplete
                    v-model="datosImprecionAll.vendedor"
                    :items="vendedoresImpresionList"
                    :search-input.sync="searchVendedorImpresion"
                    clearable
                    dense
                    item-text="nombre"
                    label="Vendedor:"
                    no-filter
                    outlined
                    return-object
                >
                  <template v-slot:prepend>
                    <i class="fa fa-user" style="font-size: 20px; width: 1.3rem"></i>
                  </template>
                </v-autocomplete>

                <!------------------------------------------------ Distribucion Contable -->
                <v-switch v-model="datosImprecionAll.distribucion" color="success" hide-detail
                          label="Distribucion Contable">
                  <template v-slot:label>
                    <strong v-if="datosImprecionAll.distribucion == true"
                            style="color: #000000; font-size: 13px">Distribucion Contable: Si</strong>
                    <strong v-if="datosImprecionAll.distribucion == false"
                            style="color: #000000; font-size: 13px">Distribucion Contable: No</strong>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr/>

        <ModalReporteFiltros :Datos="datosImprecionAll" @DataReporteBasico="DDataReporteBasico"/>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal-Reporte Basico -->
    <v-dialog v-model="dialogimprimirList" label="Modal Reporte Basico" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <ModalReporteBasico :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico"/>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Reporte Basico -->
   <!---------------------  FACTURACION ELETRONICA ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>
  
  
  </div>
</template>

<script>
import VueAutonumeric from "../../components/AutoNumericNuevo"
import ClienteInformacion from "../../components/ClienteInformacion"
import BarraBusqueda2 from "../../components/BarraBusquedaDinamLimite"
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
import NuevaCuenta from "../../components/NuevaCuenta"
import CuentasContables from "../../components/CuentasContables"
import ContenidoBase from "../../components/ContenidoBase"
import {EventBus} from "../../event-bus"
import ModalReporteFiltros from "../../components/ModalReporteFiltros"
import ModalReporteBasico from "../../components/ModalReporteBasico"
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import {
  currencyFormatter2MonedaConv,
  conversorMoneda,
  currencyFormatter,
  desConversorMoneda,
  fechaNueva,
  FormatoFecha,
  HoraFormatter,
  RedondeoBasico,
} from "@/js/Funciones.js"

export default {
  components: {
    BarraBusqueda2,
    VueAutonumeric,
    ClienteInformacion,
    NuevaCuenta,
    BarraDinamicaLimitePlus,
    CuentasContables,
    ContenidoBase,
    ModalReporteFiltros,
    ModalReporteBasico,
    PvDgiiFacturacionEletronica
  },
  mounted() {
    EventBus.$on("emitCXCNotaDebito", this.datostabla)
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    EventBus.$on("onResize", this.onResize)
    this.getMonedaBase()
  },
  created() {
    var json = {
      titulo: "Notas de Debito",
      descripcion: "aqui se registran los vendedores de la empresa",
      save: true,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: true,
      vercuenta: true,
      accion: [
        "CXCNotasDebitoNew",
        "CXCNotasDebitoSave",
        "CXCNotasDebitoRemove",
        "CXCNotasDebitoAnular",
        "CXCNotasDebitoPrintList",
        "CXCNotasVercuenta",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },

  data() {
    return {
      windowSize: {width: "auto", height: "auto"},
      loaderTabla:false,
      dialogimprimirList: false,
      dialogimprimirListFilt: false,

      datosImprecionAll: {
        nombre: "NOTA DE DEBITO",
        UrlImprimir: "/notadebitocliente/imprimirList",
        UrlExel: "/notadebitocliente/excelList",
        UrlCorreo: "/notadebitocliente/correoList",
        secuencia: 0,
        fecini: fechaNueva(),
        fecfin: fechaNueva(),
        distribucion: false,
        documentos: null,
        vendedor: null
      },

      datosImprecion: {
        nombre: "NOTA DE DEBITO",
        UrlImprimir: "/notadebitocliente/imprimir",
        UrlExel: "/notadebitocliente/excel",
        UrlCorreo: "/notadebitocliente/correo",
        secuencia: 0,
        documento: 0,
      },

      dialogFiltros: false,

      Modallfiltro: {
        factura: null,
        cliente: null,
        documento: null,
        Desde: null,
        Hasta: null,
      },

      Rmoneda: [],
      ObjTemTbDinam: null,
      ListItems: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      clientTel: "",

      disableAll: false,
      btnAgCuenta: false,

      objeTem: null,

      TotalCuenta: {
        credito: 0,
        debito: 0,
      },

      valid: true,
      RDocumento: [],
      RCliente: [],
      RLisCuenta: [],
      editCuentasC:false,
      ROrigen: [
        {codigo: 1, origen: "D", descripcion: "Crédito"},
        {codigo: 2, origen: "C", descripcion: "Debito"},
      ],

      RTipo: [
        {codigo: 1, tipo: "CO", descripcion: "Control"},
        {codigo: 2, tipo: "DE", descripcion: "Detalle"},
      ],

      RGrupo: [
        {codigo: "AC", descripcion: "Activo"},
        {codigo: "PA", descripcion: "Pasivo"},
        {codigo: "CA", descripcion: "Capital"},
        {codigo: "IN", descripcion: "Ingreso"},
        {codigo: "CO", descripcion: "Costo"},
        {codigo: "GA", descripcion: "Gasto"},
      ],

      RfilCuenta: "cuenta",
      Rcuenta: [],

      objCliAccion: false,
      ObjCliente: null,

       totalGeneral: {
          valor: 0,
          valorNdb: 0,
          itbis: 0,
          balanceTotal: 0,
        },
        tbFacCargar: false,
      ShowSelet: true,
      facSelected:[],
      listaFactura:[],
      periodoDetalle: null,
      contabilidad: null,
      NotaDebito: {
        activada: true,
        cliente: null,
        vendedor: null,
        concepto: "",
        diasCredito: 0,
        documentocxc: null,
        fecha: fechaNueva(),
        itbis: 0,
        ncf: "",
        notadebitoclientesPK: {
          secuencia: 0,
          documento: 0,
        },
        //pendiente: 250
        referencia: "",
        valor: 0,
        contabilidad: null,
        borrado: false,
        moneda: null,
        tasa: 1,
      },

      vendedoresList: [],
      searchVendedor: "",
      shouldIgnoreSearch: false,

      vendedoresImpresionList: [],
      searchVendedorImpresion: "",

      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: true,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      disabledDocumento: false,
      modalCuenta: {
        cuenta: null,
      },

      acti_Modal_cuenta: false,
      acti_Nueva_cuenta: false,

      Colss: {
        p1: 8,
      },

      headers: [{text: "Nombre", value: "cliente.nombre"}],

      slotlist: [
        // { dt0: "notadebitoclientesPK", dt1: "secuencia", dt2: null, dt3: 1, dt4: "Código:" },
        {dt0: "cliente", dt1: "nombre", dt2: null, dt3: 1, dt4: "Nombre:"},

        {
          dt0: "valor",
          dt1: null,
          dt2: null,
          dt3: 5,
          dt4: "$",
        },

        {dt0: "concepto", dt1: null, dt2: null, dt3: 1, dt4: "Concepto:"},
        {dt0: "referencia", dt1: null, dt2: null, dt3: 1, dt4: "Referencia:"},

        {dt0: "ncf", dt1: null, dt2: null, dt3: 1, dt4: "NCF:"},
        {dt0: "fecha", dt1: null, dt2: null, dt3: 2, dt4: "Fecha:"},
        {dt0: "activada", dt1: null, dt2: null, dt3: 0.1, dt4: "Anulada"},
      ],

      list: [],
      limiteTotalRegistros: 0,
      paginator: {
        itemsPerPage: 5,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },
      search: "",
      acti_tb_data: false,

      ejecucion: true,
      aalert: {
        estado: false,
        color: null,
      },
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea Anular este registro?",
      },
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
    }
  },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter, fechaNueva,
    desConversorMoneda,
    conversorMoneda,
    RedondeoBasico,
    currencyFormatter2MonedaConv,

    onResize(e) {
      //  this.windowSize = e;
    },

    // Al verificar si el cliente es nulo, si es nulo, establece el cliente en una cadena vacía.
    SelctCbClienteFiltro() {
      if (this.Modallfiltro.cliente == null) {
        this.Modallfiltro.cliente = ""
      }

      if (this.Modallfiltro.cliente.codigo == undefined) {
        this.alerta("Seleccione un cliente", "error")
        this.Modallfiltro.cliente = ""

        //qlq2

        return
      }
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbDocumentoFiltro() {
      if (this.Modallfiltro.documento == null) {
        this.Modallfiltro.documento = ""
      }

      if (this.Modallfiltro.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.Modallfiltro.documento = ""
        return
      }
    },

    SelctCbReportDocumento() {
      if (this.datosImprecionAll.documentos == null) {
        this.datosImprecionAll.documentos = ""
      }

      if (this.datosImprecionAll.documentos.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.datosImprecionAll.documentos = ""
        return
      }
    },

    ActivarSave(json) {
      EventBus.$emit("ActDesaBotones", json)
    },

    // Validando el formulario y luego llamando al método getcuenta().
    getCrear() {
      //aquiiii

      if (this.$refs.form.validate()) {
        if (this.NotaDebito.notadebitoclientesPK.secuencia == 0) {
          this.getcuenta()
        }
      }

        


    },

    AddCuenta() {
      if (this.$refs.formCuenta.validate()) {
        var json = {
          cuenta: {
            cuenta: this.modalCuenta.cuenta.cuenta,
            descripcion: this.modalCuenta.cuenta.descripcion,
          },
          debito: 0,
          credito: 0,
        }
        this.RLisCuenta.push(json)
        this.NotaDebito.RLisCuenta = this.RLisCuenta
        this.modalCuenta.cuenta = null
      } else {
        this.alerta("Los campos marcados en rojo son  obligatorios", "error")
      }
    },

    deleCuenta(item) {
      var eliminar
      const index = this.RLisCuenta.indexOf(item)
      eliminar =
          confirm("Desea eliminar este Cuenta?") &&
          this.RLisCuenta.splice(index, 1)

      if (eliminar != false) {
        this.calcularTotal(1)
      }
    },

    NnuevaCuenta(e) {
      this.acti_Nueva_cuenta = e
    },

    SelctCbcuenta() {
      if (this.modalCuenta.cuenta == null) {
        this.modalCuenta.cuenta = ""
      }

      if (this.modalCuenta.cuenta.cuenta == undefined) {
        this.alerta("Seleccione una Cuenta", "error")
        this.modalCuenta.cuenta = ""
        return
      }
    },

    cerrarmodalcuenta() {
      if (this.RLisCuenta.length > 0) {
        this.RLisCuenta = JSON.parse(JSON.stringify(this.objeTem))
        this.calcularTotal(1)
      }

      this.acti_Modal_cuenta = !this.acti_Modal_cuenta
    },

    saveCuenta() {
      if (this.NotaDebito.Total.credito != this.NotaDebito.Total.debito) {
        this.alerta(
            "El total de debito y credito no coincide en el asiento contable",
            "error",
        )
        return
      }

      this.acti_Modal_cuenta = !this.acti_Modal_cuenta

      this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta))
      this.modalCuenta.cuenta = null
    },

    CCuentasContables(e, t, b) {
      if (e != undefined) {
        if (e.length == 0) {
          this.getcuenta()
        } else {
          // this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
          // this.form.TotalCuenta=JSON.parse(JSON.stringify(t))
          this.RLisCuenta = JSON.parse(JSON.stringify(e))
          //this.RLisCuenta= this.RLisCuenta
          this.TotalCuenta = JSON.parse(JSON.stringify(t))
        }
      }

      this.acti_Modal_cuenta = b
      this.editCuentasC=true
    },

    vercuenta() {
      if (this.$refs.form.validate()) {
        this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta))
        this.TotalCuenta = JSON.parse(JSON.stringify(this.TotalCuenta))
        this.acti_Modal_cuenta = !this.acti_Modal_cuenta

        var _this = this;
        setTimeout(function () {
          // _this.calcularTotalcuenta(1)
          _this.$refs.RefCuentasContables.calcularTotal(1);
        }, 500);


      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },

    cargarPaginacion(e) {
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
      }

      this.filtro()
    },

    fecFormatter(params) {
      if (params != null) {
        if (params.length > 0) {
          return (
              params.substring(8, 10) +
              "-" +
              params.substring(5, 7) +
              "-" +
              params.substring(0, 4)
          )
        }
      }
    },

    currencyFormatter(number) {
      if (number == null) {
        number = 0
      }
      return number
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    },

    // Comprobar si la clave es un número o no.
    DiaCre(e) {
      if (e.key) {
        var mynumeral = require("numeral")
        this.NotaDebito.diasCredito = mynumeral(
            this.NotaDebito.diasCredito,
        ).value()
        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (this.NotaDebito.diasCredito == null) {
          this.NotaDebito.diasCredito = 0
        }
      } else {
        console.log("no se puede poner letras o signos")
      }
    },

    SelctCbCuentaValidControl() {
      if (this.modalCuenta.cuenta != null) {
        if (this.modalCuenta.cuenta.tipo == "CO") {
          this.alerta("No puede seleccionar una cuenta control", "error")
          this.modalCuenta.cuenta = null
        }
      }
    },

    CargarRcuenta() {
      this.$axios
          .get(this.$hostname + this.$hName + "/catalogo/findall", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.Rcuenta = res.data
          })
    },

    CbFilCuenta(e) {
      if (e.target.value.length == 1) {
        if (
            (e.target.value.charCodeAt(0) >= 97) &
            (e.target.value.charCodeAt(0) <= 122)
        ) {
          this.RfilCuenta = "descripcion"

          this.CargarRcuenta()
        } else {
          this.RfilCuenta = "cuenta"
        }

        if (
            (e.target.value.charCodeAt(0) >= 48) &
            (e.target.value.charCodeAt(0) <= 57)
        ) {
          this.CargarRcuenta()

          this.RfilCuenta = "cuenta"
        } else {
          this.RfilCuenta = "descripcion"
        }

        //numero 48 a 57
        //letras 97 a 122
      }
    },

    // Una función que se llama cuando el usuario selecciona un cliente del menú desplegable.
    ClienteSelect(e) {
      if (e != null) {
        if (e.hasOwnProperty("codigo")) {
          this.ObjCliente = e

          if (e.telefonosClientesList.length > 0) {
            this.clientTel = "Tel." + e.telefonosClientesList[0].telefonosClientesPK.telefono
          } else {
            this.clientTel = ""
          }

          if (e.vendedor) {
            this.findVendedorById(e.vendedor)
          }
        } else {
          this.BarraSecundariaAprir = false
          this.clientTel = ""
        }
      }
    },

    /**
     * @param {number} id Id de vendedor a buscar
     */
    findVendedorById(id) {
      this.$axios
          .get(this.$hostname + this.$hName + `/vendedores/find/${id}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.NotaDebito.vendedor = res.data
            this.vendedoresList = [res.data]
          })
          .catch((error) => {
            console.error(error)
          })
    },

    // Hacer una llamada API al servidor y devolver los datos.
    CbFilcliente(e) {
      if (e.target.value.length >= 0) {
        this.Rproducto = []

        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then((res) => {
              this.RCliente = res.data
            })
            .catch((err) => {
              console.log("Dio un error")
            })
      }
    },

    // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
    cargarCliente() {
      this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RCliente = res.data))
    },

    // Al verificar si el cliente es nulo, si es nulo, establece el cliente en una cadena vacía.
    SelctCbCliente() {
      if (this.NotaDebito.cliente == null) {
        this.NotaDebito.cliente = ""
      }

      if (this.NotaDebito.cliente.codigo == undefined) {
        this.alerta("Seleccione un cliente", "error")
        this.NotaDebito.cliente = ""
        return
      }
      this.NotaDebito.diasCredito = this.NotaDebito.cliente.diascredito
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RDocumento.
    cargarDocumento() {
      this.$axios
          .get(
              this.$hostname +
              this.$hName +
              "/documentocxc/findallDocumentosNotaDebito",
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => (this.RDocumento = res.data))
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbDocumento() {
      if (this.NotaDebito.documentocxc == null) {
        this.NotaDebito.documentocxc = ""
      }

      if (this.NotaDebito.documentocxc.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.NotaDebito.documentocxc = ""
        return
      }
      if (this.NotaDebito.documentocxc.operaciones.codigo != 21 && this.NotaDebito.documentocxc.comprobante) {

        var codSuc = this.NotaDebito.documentocxc.sucursal
        this.$axios.get(this.$hostname + this.$hName + `/sucursal/findbyid/${codSuc}`, {headers: this.$store.getters.GetheadersAxios}).then(res => {
          this.validarNCF(this.NotaDebito.documentocxc.codigo, 9, this.NotaDebito.documentocxc.operaciones.modulo.trim(), res.data.rnc.trim())
        })


      }
    },
    // Realización de una solicitud al servidor para validar el número de documento.
    validarNCF(documento, tipo, modulo, rnc) {
      console.log(documento)
      console.log(tipo)
      console.log(modulo)
  //YNA-1-05-2026: por el tipo de comprobante no encontraba secuencia
  /*this.$axios .get( this.$hostname +  this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + documento + "/" + tipo + "/" + modulo.trim() + "/" + rnc.trim(),
              {headers: this.$store.getters.GetheadersAxios},)*/ 

      this.$axios .get( this.$hostname +  this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + documento + "/"+ modulo.trim() + "/" + rnc.trim(),
              {headers: this.$store.getters.GetheadersAxios},)
          .then((res) => {
            if (!res.data) {
              this.alerta("Este documento no tiene comprobante y es requerido", "error")
              return
            }
          })
    },

    // muestra una tabla de datos.
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      if (this.BarraTablaDinamicaAprir == true) {
        this.Limpiarfiltro()
      }
    },

    abrirTabla2() {
      this.BarraSecundariaAprir = !this.BarraSecundariaAprir
    },

    // Creando un nuevo objeto y asignándolo a la variable NotaDebito.
    newwnuevo() {
      this.BarraTablaDinamicaAprir = false
      this.contabilidad = null,
          this.RLisCuenta = [],
          this.facSelected=[]
         this.listaFactura=[]

          this.TotalCuenta = {
            credito: 0,
            debito: 0,
          };
          this.editCuentasC=false;

      (this.NotaDebito = {
        activada: true,
        cliente: null,
        concepto: "",
        diasCredito: 0,
        documentocxc: null,
        fecha: fechaNueva(),
        itbis: 0,
        ncf: "",
        vendedor: null,
        notadebitoclientesPK: {
          secuencia: 0,
        },
        //pendiente: 250
        referencia: "",
        valor: 0,
        moneda: null,
        tasa: null,
      }),
          (this.RLisCuenta = []),
          (this.disabledDocumento = false),
          (this.disableAll = false)

      this.BarraSecundariaAprir = false;

      (this.objeTem = []), (this.ejecucion = true)
      EventBus.$emit("actualizaBarraBusqueda2")
      this.getMonedaBase()
      EventBus.$emit("loading", false)

    },

    async presave() {
      EventBus.$emit("loading", true);
      var _this = this;
      setTimeout(function () {
        _this.save();
      }, 1000);

    },

    // Guardando los datos en la base de datos.
    async save() {
      if (this.NotaDebito.activada == false) {
        this.alerta("Esta nota de debito esta anula", "error")
        return
      } 

      if (this.TotalCuenta.credito != this.TotalCuenta.debito) {
        this.acti_Modal_cuenta = true
        this.alerta(
            "El total de debito y credito no coincide en el asiento contable",
            "error",
        )
        return
      }


      if(this.NotaDebito.itbis>0){
          var VAR_ITBIS =this.RedondeoBasico((this.NotaDebito.valor*0.18))
          if(VAR_ITBIS!= this.RedondeoBasico((this.NotaDebito.itbis))){
            this.alerta("NOTA: El itbis al 18 no coincide con el monto", "error")
            return
          }
          

          
      }


      if (this.RLisCuenta.length === 0) {
        this.getcuenta()
      }

      if (this.$refs.form.validate()) {
        if (this.ejecucion == true) {
          this.ejecucion = false

          var jsn = {
            datos: JSON.parse(JSON.stringify(this.NotaDebito)),
            RLisCuenta: JSON.parse(JSON.stringify(this.RLisCuenta)),
            usuario: JSON.parse(JSON.stringify(this.$user)),
          }
          this.NotaDebito.contabilidad = this.contabilidad
          if (typeof this.NotaDebito.contabilidad != 'object' || this.NotaDebito.contabilidad === null) {
            this.NotaDebito.contabilidad = {
              activo: true,
              borrado: false,
              comentario: "",
              contabilidadDetalleList: [],
              documento: this.NotaDebito.documentocxc.codigo,
              dsc: null,
              empresa: 0,
              entradaDiario: null,
              fecha: this.NotaDebito.fecha,
              id: null,
              operaciones: this.NotaDebito.documentocxc.operaciones,
              referencia: "",
            }
          }

          if (this.RLisCuenta.length > 0) {
            this.NotaDebito.contabilidad.contabilidadDetalleList = this.RLisCuenta
          } else {
            this.NotaDebito.contabilidad.contabilidadDetalleList = []
          }

          if (typeof this.NotaDebito.contabilidad.contabilidadDetalleList != 'object' || this.NotaDebito.contabilidad.contabilidadDetalleList === null) {
            this.form.NotaDebito.contabilidad.contabilidadDetalleList = []
          }

          //this.NotaDebito.tasa= JSON.parse(JSON.stringify(this.NotaDebito.moneda.tasa))
          var NOTA_DEBITO = JSON.parse(JSON.stringify(this.NotaDebito))
          NOTA_DEBITO.tasa = JSON.parse(JSON.stringify(this.NotaDebito.moneda.tasa))
          NOTA_DEBITO.valor = this.RedondeoBasico(this.desConversorMoneda(this.NotaDebito.valor, this.NotaDebito.tasa))
          NOTA_DEBITO.itbis = this.RedondeoBasico(this.desConversorMoneda(this.NotaDebito.itbis, this.NotaDebito.tasa))
        if(this.facSelected.length>0){
          NOTA_DEBITO.facturasventa=this.facSelected[0]
        }
       
          EventBus.$emit("loading", true)
          try {
            var res = await this.$axios.post(
                this.$hostname + this.$hName + "/notadebitocliente/save",
                NOTA_DEBITO,
                {headers: this.$store.getters.GetheadersAxios},
            )

            if(res.data.facturasventa!=null && res.data.documentocxc.hasOwnProperty('datoSucursal')&& res.data.documentocxc.datoSucursal!=null && res.data.documentocxc.datoSucursal.facturacionEletronica==true){
              if(!res.data.facturasventa.hasOwnProperty('trackId') || res.data.facturasventa.hasOwnProperty('trackId') && res.data.facturasventa.trackId==null || res.data.facturasventa.trackId!=null && !res.data.facturasventa.trackId.includes("estado")){
                await this.anularNotaDebitoGuardada(res.data)
                this.alerta("NOTA: La factura seleccionada no ha sido emitida en el proceso eletronico. La nota de debito fue anulada.", "error")
                return
              }

              if(res.data.facturasventa.hasOwnProperty('trackId') &&  res.data.facturasventa.trackId!=null && res.data.facturasventa.trackId.includes("Rechazado")){
                await this.anularNotaDebitoGuardada(res.data)
                this.alerta("NOTA: La factura seleccionada fue RECHAZADA en el proceso eletronico. La nota de debito fue anulada.", "error")
                return
              }

              if(res.data.facturasventa.hasOwnProperty('trackId') &&  res.data.facturasventa.trackId!=null && res.data.facturasventa.trackId.includes("Aceptado")){
                var envioCorrecto = await this.facturacionEletronicaGet(res.data)
                if(!envioCorrecto){
                  await this.anularNotaDebitoGuardada(res.data)
                  this.alerta("NOTA: Error enviando el comprobante electronico. La nota de debito fue anulada.", "error")
                  return
                }
              }
            }

            this.alerta("Dato guardado correctamente", "bien")
          } catch (error) {
            this.alerta(error, "error")
          }
        }
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },

    // Alternando el estado de la variable Elim_notif.estado.
    anular() {
      this.Elim_notif.estado = !this.Elim_notif.estado
    },

    // Al verificar si el objeto tiene un valor, si lo tiene, verificará si el formulario es válido, si
    // es válido, creará un objeto JSON y lo enviará al servidor.
    eliminar() {
      if (
          this.NotaDebito.notadebitoclientesPK.secuencia != 0 &&
          this.NotaDebito.notadebitoclientesPK.secuencia != null
      ) {
        if (this.$refs.form.validate()) {

          if (this.NotaDebito.codpagare != null) {
            this.alerta(`Este Nota de Debito no se puede anular, porque esta enlazado a el contrato pagaré #${this.NotaDebito.codpagare}. `, "error")
            return
          }

          var jsn = {
            datos: JSON.parse(JSON.stringify(this.NotaDebito)),
            usuario: JSON.parse(JSON.stringify(this.$user)),
            contabilidad: JSON.parse(JSON.stringify(this.contabilidad)),
          }


          EventBus.$emit("loading", true)
          this.$axios
              .post(
                  this.$hostname + this.$hName + "/notadebitocliente/tienemovimiento",
                  this.NotaDebito,
                  {headers: this.$store.getters.GetheadersAxios},
              )
              .then((res) => {
                if (res.data == true) {
                  this.alerta("Esta nota de débito posee movimiento, no se puede anular", "error")
                } else {

                  this.$axios
                      .post(
                          this.$hostname + this.$hName + "/notadebitocliente/anular",
                          this.NotaDebito,
                          {headers: this.$store.getters.GetheadersAxios},
                      )
                      .then((res) => {

                        if (res.data == false) {
                          this.alerta("Nota de debito anulado correctamente !", "bien")
                        } else {
                          this.alerta("Dato no anulado correctamente !", "error")
                        }

                      })
                      .catch((error) => {
                        this.alerta(error, "error")
                      })


                }
              })
              .catch((error) => {
                this.alerta(error, "error")
              })


          /*
                    
          
          */


        }
      }
    },

    remove() {
    },
    // muestra un modal para elejir las opciones de reporte.
    imprimirList() {
      if (this.NotaDebito.notadebitoclientesPK.secuencia > 0) {
        this.datosImprecion.secuencia = this.NotaDebito.notadebitoclientesPK.secuencia
        this.datosImprecion.documento = this.NotaDebito.notadebitoclientesPK.documento
        this.dialogimprimirList = true

        if(this.NotaDebito.hasOwnProperty('facturasventa') && this.NotaDebito.facturasventa!=null){
          this.datosImprecion.numfact =`${this.NotaDebito.facturasventa.documentoFactura.nombrecorto.trim()}-${this.NotaDebito.facturasventa.facturasventaPK.secuencia}`
        }else{
          this.datosImprecion.numfact =null
        }
     
     if(this.NotaDebito.hasOwnProperty('qrdgii') && this.NotaDebito.qrdgii!=null && this.NotaDebito.qrdgii.trim().length>0){
      this.datosImprecion.qrdgii=this.NotaDebito.qrdgii
      this.datosImprecion.signatureValue=this.NotaDebito.signatureValue
      this.datosImprecion.fechafirmadgii=this.NotaDebito.fechafirmadgii
      }else{
      this.datosImprecion.qrdgii=null
      this.datosImprecion.signatureValue=null
      this.datosImprecion.fechafirmadgii=null 
      }
     
      } else {
        this.alerta("Seleccione una reposición de caja chica para poder imprimir", "error")
      }
    },
//Retorna los  objectos del componente ModalReporteBasico
    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },

    datostabla(e) {
      this.facSelected=[]
      this.listaFactura=[]
      this.contabilidad = null;
      (this.RLisCuenta = []), (this.acti_tb_data = false)
      this.disableAll = false
      // e.fecha = new Date(e.fecha).toISOString().substr(0, 10);

      if (e.moneda != null) {
        e.moneda.tasa = e.tasa
      }
      this.NotaDebito = JSON.parse(JSON.stringify(e))
      this.NotaDebito.fecha = e.nuevaFecha
      this.NotaDebito.valor = this.RedondeoBasico(this.conversorMoneda(e.valor, e.tasa))
      this.NotaDebito.itbis = this.RedondeoBasico(this.conversorMoneda(e.itbis, e.tasa))
      if (e.cliente != null) {
        this.ClienteSelect(this.NotaDebito.cliente)
      }
      (this.TotalCuenta = {
        credito: 0,
        debito: 0,
      }),
          (this.disabledDocumento = true)

      this.disableAll = true
      if (e.activada == false) {
        this.disableAll = true
      } else {
        this.getcuenta()
      }

      if (this.NotaDebito.vendedorCodigo != null) {
        this.findVendedor()
      }

if(e.hasOwnProperty('facturasventa')&& e.facturasventa!=null){
var FACt= JSON.parse(JSON.stringify(e.facturasventa))

FACt.itbis=0
FACt.valorNdb=(e.valor+e.itbis)
FACt.balanceTotal=(FACt.valor+e.valor+e.itbis)
this.listaFactura.push(FACt)

 var _this = this
        setTimeout(function() {
          _this.facSelected=_this.listaFactura
        }, 900)
        
        /**/


}



    },

    // Llamar a una función que está en el backend.
    getcuenta() {
      if (this.editCuentasC==false && this.NotaDebito.notadebitoclientesPK.secuencia == 0) {
        EventBus.$emit("loading", true);
        var jsn = {
          datos: JSON.parse(JSON.stringify(this.NotaDebito)),
          usuario: JSON.parse(JSON.stringify(this.$user)),
        }
        var VALOR_EN_BASE = this.RedondeoBasico(this.desConversorMoneda(this.NotaDebito.valor, this.NotaDebito.tasa))
        var ITBIS_EN_BASE = this.RedondeoBasico(this.desConversorMoneda(this.NotaDebito.itbis, this.NotaDebito.tasa))
        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/contabilidad/crear-contabilidad-cxc/" +
                this.NotaDebito.documentocxc.codigo +
                "/" +
                VALOR_EN_BASE +
                "/" +
                ITBIS_EN_BASE +
                "/0/0/0/0/0",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then((res) => {
              this.llenarcuenta(res.data)
              EventBus.$emit("loading", false);
            })
      } 
      
     if (this.RLisCuenta.length==0 && this.NotaDebito.notadebitoclientesPK.secuencia != 0) {
      EventBus.$emit("loading", true);
        var jsn1 = {
          datos: JSON.parse(JSON.stringify(this.NotaDebito)),
          usuario: JSON.parse(JSON.stringify(this.$user)),
        }

        this.dataaaa = JSON.parse(JSON.stringify(jsn1))

        //anja aquii
        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/contabilidad/findContabilidad/" +
                this.NotaDebito.notadebitoclientesPK.documento +
                "/" +
                this.NotaDebito.notadebitoclientesPK.secuencia +
                "/" +
                this.NotaDebito.documentocxc.operacion,
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then((res) => {
              this.llenarcuenta(res.data)
              EventBus.$emit("loading", false);
            })
      }
    },

    async llenarcuenta(e) {
      //Object.assign([], e);
      //this.RLisCuenta= e
      if (typeof this.contabilidad != 'object' || this.contabilidad === null) {
        if (typeof e === 'object' && e != null) {
          this.contabilidad = e;
        } else {
          this.contabilidad = {
            activo: true,
            borrado: false,
            comentario: "",
            contabilidadDetalleList: [],
            documento: this.NotaDebito.documentocxc.codigo,
            dsc: null,
            empresa: 0,
            entradaDiario: null,
            fecha: this.NotaDebito.fecha,
            id: null,
            operaciones: this.NotaDebito.documentocxc.operaciones,
            referencia: ""
          }
        }

        this.contabilidad.fecha = this.NotaDebito.fecha;
        this.contabilidad.documento = this.NotaDebito.documentocxc.codigo;
        // this.contabilidad
      }


      if (e.contabilidadDetalleList != null && typeof e.contabilidadDetalleList === 'object' && e.contabilidadDetalleList.length > 0) {

        var obj = JSON.parse(JSON.stringify(e.contabilidadDetalleList));
        await Promise.all(obj.map(async (elee) => {
          if (elee.hasOwnProperty("borrado")) {
            elee.borrado = false;
          }
          if (!elee.hasOwnProperty("credito")) {
            elee.credito = 0;
          }
          if (!elee.hasOwnProperty("debito")) {
            elee.debito = 0;
          }

          if (elee.cuenta == null) {
            const index = obj.indexOf(elee)
            obj.splice(index, 1)
          }
        }));


        var _this = this;
        setTimeout(function () {
          _this.RLisCuenta = JSON.parse(JSON.stringify(e.contabilidadDetalleList));
          // _this.form.RLisCuenta = JSON.parse(JSON.stringify(_this.RLisCuenta));
          _this.objeTem = JSON.parse(JSON.stringify(_this.RLisCuenta));
          // _this.calcularTotalcuenta(1)
        }, 500);

      }


      /* await obj.forEach((elee) => {
         if(elee.hasOwnProperty("borrado")){elee.borrado = false; }
        if(!elee.hasOwnProperty("credito")){elee.credito = 0;}
         if(!elee.hasOwnProperty("debito")) {elee.debito = 0;}
         if (elee.cuenta == null) {
           const index = obj.indexOf(elee);
           obj.splice(index, 1);
         }
       });*/

    },
    buscarPeriodo(e) {

      if (this.NotaDebito.fecha != null) {
        this.$axios
            .get(
                this.$hostname + this.$hName + "/contabilidad/findPeriodo/" + this.NotaDebito.fecha,
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then((res) => {
              if (res.data === "") {
                this.alerta("No existen periodo para esta fecha", "error")
              }
              this.periodoDetalle = res.data
              if (this.periodoDetalle.cerrado === true) {
                this.alerta(
                    "Periodo esta cerrado no puede trabajar en esta fecha",
                    "error",
                )
              }
            })
            .catch((err) => {
              console.log(err),
                  this.alerta("No existen periodo para esta fecha", "error")
            })
      }
    },
    calcularTotal(e) {
      this.TotalCuenta = {
        credito: 0,
        debito: 0,
      }

      if (e.toString().length > 0) {
        this.RLisCuenta.forEach((element) => {
          this.TotalCuenta.credito += element.credito
          this.TotalCuenta.debito += element.debito
        })
      }
    },

    // Un método que se llama cuando se hace clic en un botón.
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.Limpiarfiltro()
    },

    // Restableciendo la paginación y el filtro.
    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      this.Modallfiltro = {
        factura: null,
        cliente: null,
        documento: null,
        Desde: null,
        Hasta: null,
      }

      this.ListItems = []
      this.TbTotalItem = 0
      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false
    },

    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      if (
          this.Modallfiltro.factura != null &&
          this.Modallfiltro.factura.toString().length == 0
      ) {
        this.Modallfiltro.factura = null
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false
    },

    // Un método que se llama cuando el usuario cambia el número de elementos por página.
    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      this.CargarPaginacion(e, this.Modallfiltro.cliente)
    },

    // Una función que se llama cuando el usuario cambia el número de elementos por página.
    CargarPaginacion(e, s) {
      this.Modallfiltro.factura = JSON.parse(JSON.stringify(s))

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.CargarListTb()
    },

    CargarListTb() {
      var clie = null
      var doc = null

      if (this.Modallfiltro.cliente != null) {
        clie = this.Modallfiltro.cliente.codigo
      }
      if (this.Modallfiltro.documento != null) {
        doc = this.Modallfiltro.documento.codigo
      }
      var obj =
          this.TbPaginator.itemsPerPage +
          "/" +
          this.TbPaginator.pageStart +
          "/" +
          this.Modallfiltro.factura +
          "/" +
          clie +
          "/" +
          doc +
          "/" +
          this.Modallfiltro.Desde +
          "/" +
          this.Modallfiltro.Hasta
      this.$axios
          .get(
              this.$hostname +
              this.$hName +
              "/notadebitocliente/findListNotaDebitoPlus/" +
              obj,
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => {
            this.ListItems = res.data.ListItems
            this.TbTotalItem = res.data.TbTotalItem
          })
          .catch((error) => {
            console.error(error)
          })
    },

    getMonedaBase() {
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      this.NotaDebito.moneda = MONEDA
      this.NotaDebito.tasa = MONEDA.tasa
    },

    cargarMoneda() {
      this.$axios
          .get(this.$hostname + this.$hName + "/monedas/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.Rmoneda = res.data))
    },
    SelctCbMoneda() {
      var _this = this
      setTimeout(function () {
        if (_this.NotaDebito.moneda == null) {
          _this.NotaDebito.moneda = ""
        }

        if (!_this.NotaDebito.moneda.hasOwnProperty("codigo")) {
          _this.NotaDebito.moneda = ""
          _this.NotaDebito.moneda = null
          _this.getMonedaBase()
          return
        }
      }, 300)
    },


    ChangeMonedaTasa(e) {
      if (typeof e === "object" && e != null) {
        this.NotaDebito.tasa = JSON.parse(JSON.stringify(e.tasa))

      }
    },


async obtenerDatoDetFact(e) {
this.datosRowSelect(e.item)

},

async datosRowSelect(e) {
this.loaderTablaCargar()

if(this.facSelected.length>0 && this.facSelected[0].indx===e.indx){
   e.valorNdb=0
  e.balanceTotal=0
   this.facSelected= []
  return
}

 this.facSelected= []

await Promise.all(this.listaFactura.filter((ee) => ee.indx!= e.indx && ee.valorNdb>0).map(async (element) => {
            element.valorNdb=0
            element.balanceTotal=0
          }))

 if(this.NotaDebito.valor>0){
  e.valorNdb=(this.NotaDebito.valor+this.NotaDebito.itbis)
  e.balanceTotal=(e.valor+this.NotaDebito.valor+this.NotaDebito.itbis)
 }

 this.facSelected.push(JSON.parse(JSON.stringify(e)))

     /* var _this = this
        setTimeout(function() {
          _this.facSelected.push(JSON.parse(JSON.stringify(e)))
        }, 900)*/
    },

    getMonedaBase(){
    var MONEDA=JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
    if(this.NotaDebito.moneda==null || this.NotaDebito.moneda!=null && !this.NotaDebito.moneda.hasOwnProperty('codigo')){
      this.NotaDebito.moneda= MONEDA
      this.NotaDebito.tasa=MONEDA.tasa
    }
},


async FactPendientes() {
    //  this.form.NotasCredito.notaCreditoClienteDetalleList = []
      //this.form.objeTemCDt = []
      if (this.NotaDebito.cliente != null) {
        this.$axios.get(this.$hostname + this.$hName + '/notadebitocliente/getFacturaPendiente/' + this.NotaDebito.cliente.codigo,
            {headers: this.$store.getters.GetheadersAxios})
            .then(async res => {
              if (res.data === null) {
                this.alerta(error, "Este cliente no posee facturas pendientes");
              } else {

      this.listaFactura= await Promise.all(
          res.data.map(async item => ({
            ...item,
             itbis:item.valorimpuesto,
            valorNdb:0,
            balanceTotal:0

          }))
        );

                //this.listaFactura=res.data
              }
            })
            .catch(err => {
              console.log(err.data)
            });
      }

    },

getValorNBD(valor){
      if(this.facSelected.length>0){

Promise.all(this.listaFactura.map(async (element) => {
if(this.facSelected[0].indx===element.indx){
     this.facSelected[0].valorNdb=valor
     this.facSelected[0].balanceTotal=(element.valor+valor)
      element.valorNdb=valor
      element.balanceTotal=(element.valor+valor)    
}else{
      element.valorNdb=0
      element.balanceTotal=0
}

}));

this.loaderTablaCargar()

      }

    },

async calcularTotalFooter(){
  //@current-items="calcularTotalFooter(listaFactura)"
//console.log('LISTA--->',LISTA)

this.totalGeneral= {
          valor: 0,
          valorNdb: 0,
          itbis: 0,
          balanceTotal: 0,
        }

this.totalGeneral.valor = this.listaFactura.reduce((total, item) => total + item.valor, 0);
this.totalGeneral.valorNdb = this.listaFactura.reduce((total, item) => total + item.valorNdb, 0);
this.totalGeneral.itbis = this.listaFactura.reduce((total, item) => total + item.itbis, 0);
this.totalGeneral.balanceTotal = this.listaFactura.reduce((total, item) => total + item.balanceTotal, 0);



       /*  var _this = this;
        setTimeout(function () {
          // _this.calcularTotalcuenta(1)
            Promise.all(_this.listaFactura.map(async (element) => {
              // if(element.hasOwnProperty('itbis')&& element.itbis!=null ){ }
                _this.totalGeneral.itbis+=  element.itbis
                _this.totalGeneral.valorNdb+=  element.valorNdb
                _this.totalGeneral.valor+=  element.valor
                _this.totalGeneral.balanceTotal+=element.balanceTotal
            
          }))
        }, 1000);*/

 

},



async facturacionEletronicaGet(NOTDB){
  //NOTDB.facturasventa.nuevaFecha=NOTDB.facturasventa.fecha
    var CodigoModificacion=3;
    try {
      var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_NOTADEBITO_CXC(NOTDB,CodigoModificacion);

   /**/ if (resObjCompleto.objtrackId.estado === "Rechazado") {
        var msj_Error = ""

        Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
          msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
        }))

        this.alerta(msj_Error, "error")
        return false
      }
      return await this.actualizarFAC_ELETRONICA( NOTDB, resObjCompleto)
    } catch (error) {
      console.log("Envio electronico nota de debito no completado-->", error)
      return false
    }

    },


    async actualizarFAC_ELETRONICA(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notadebitoclientesPK.documento,
        secuencia: FACT.notadebitoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      try {
        await this.$axios.post(this.$hostname + this.$hName + "/notadebitocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        return objCompTrackId.objtrackId.estado === "Aceptado" || objCompTrackId.objtrackId.estado === "Aceptado Condicional"
      } catch (error) {
        console.log("actualizartoken no guardado correctamente-->", error)
        return false
      }

    },

    async anularNotaDebitoGuardada(notaDebito) {
      try {
        await this.$axios.post(
            this.$hostname + this.$hName + "/notadebitocliente/anular",
            notaDebito,
            {headers: this.$store.getters.GetheadersAxios},
        )
      } catch (error) {
        console.log("Nota de debito no anulada correctamente-->", error)
      }
    },


    loaderTablaCargar(){
      this.loaderTabla=true
var _this=this;
setTimeout(function(){ _this.loaderTabla=false }, 900);
    },
    alerta(e, l) {
      console.log('Viendo--alert-->')
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e)

        this.ejecucion = true
        EventBus.$emit("loading", false)
      }
    },

    async filtro() {
      await this.$axios
          .get(this.$hostname + this.$hName + "/notadebitocliente/findall", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.list = res.data
          })
    },

    findAllVendedores() {
      this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchVendedor,
            },
          })
          .then((res) => {
            this.vendedoresList = res.data.content
          })
          .catch((error) => {
            console.error(error)
          })
    },

    findAllVendedoresImpresion() {
      this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchVendedorImpresion,
            },
          })
          .then((res) => {
            this.vendedoresImpresionList = res.data.content
          })
          .catch((error) => {
            console.error(error)
          })
    },

    findVendedor() {
      let id = this.NotaDebito.vendedorCodigo
      this.shouldIgnoreSearch = true
      this.$axios
          .get(this.$hostname + this.$hName + `/vendedores/find/${id}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.NotaDebito.vendedor = res.data
            this.vendedoresList = [res.data]
            this.shouldIgnoreSearch = false
          })
          .catch((error) => {
            console.error(error)
          })
    },
  },

  computed: {
   
    ActDescBtn() { 
      if (this.NotaDebito.notadebitoclientesPK.secuencia > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: true,
          imprimir: true,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }

        if (this.NotaDebito.activada == false) {
          this.EstadoBtn.vercuenta = false
          this.EstadoBtn.guardar = false
          this.EstadoBtn.anular = false
        } else {
          this.EstadoBtn.vercuenta = true

          if(this.NotaDebito.hasOwnProperty('trackId')&& this.NotaDebito.trackId!=null && this.NotaDebito.trackId.includes("Aceptado")){
            this.EstadoBtn.guardar = false
          this.EstadoBtn.anular = false
          }

          if(this.NotaDebito.hasOwnProperty('trackId')&& this.NotaDebito.trackId!=null && this.NotaDebito.trackId.includes("Rechazado")){ 
            this.EstadoBtn.guardar = false
            this.EstadoBtn.anular = true
          }

        }

      }

      if (this.NotaDebito.notadebitoclientesPK.secuencia <= 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }

      this.getMonedaBase()
      this.windowSize = JSON.parse(
          JSON.stringify(this.$store.getters.GetwindowSize),
      )
      //EventBus.$emit("ActDesaBotones", objjct);
    },
  },

  watch: {
    searchVendedor() {
      if (!this.shouldIgnoreSearch) {
        this.findAllVendedores()
      }
    },

    searchVendedorImpresion() {
      this.findAllVendedoresImpresion()
    },

    vendedoresList() {
      if (this.NotaDebito.vendedor && !this.vendedoresList.includes(this.NotaDebito.vendedor)) {
        this.vendedoresList.unshift(this.NotaDebito.vendedor)
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.border-total {
  border: 2px solid #757575;
  border-bottom: 6px double #757575;
}

.border-top-bottom {
  border-top: 2px solid #757575;
  border-bottom: 2px solid #757575;
}
</style>



